<template>
  <div>
    <div class="search">
      <el-input placeholder="请输入专业名称" v-model="specialty_name" @keyup.enter.native="searchName()"
        class="input-with-select">
        <el-button slot="append" @click="searchName()">
          <img src="@/assets/img/home/search.png" alt="" />
        </el-button>
      </el-input>
    </div>

    <div class="like" v-if="testtt">
      意向专业：<div v-for="(value, i) in testtt" class="specialty-item-like border-1" :key="i" @click="addSpecialty(value)">
        <div class="specialty-info">
          <div class="specialty-name">
            {{ value }} <span class="btn color-1 border-2 " v-if="SearchList.indexOf(value) > -1">
              已加入
            </span>
            <span class="btn color-1" v-else>
              +对比
            </span>
          </div>
        </div>

      </div>
      <hr>
    </div>

    <div class="refulsh" @click="getRefulsh">
      <div>
        推荐专业
      </div>
      <div class="huanyipi">
        换一批 <i class="iconfont luming-pc-shuaxin" style="font-size: 22px; margin-right: 15px; "></i>
      </div>
    </div>


    <div v-if="SearchList.length > 0" class="search-list">
      <div class="search-list-content">
        <div class="search-title search-list-item color-2">已选专业：</div>
        <div class="search-list-item border-2 " v-for="(item, i) in SearchList" :key="i">
          {{ item }}
        </div>
      </div>
      <div class="toSearch search-list-item">
        <el-button size="mini" @click="onSearch">开始对比</el-button>
      </div>

    </div>

    <div class="specialty-item border-1" @click="addSpecialty(item.specialty_name)" v-for="(item, key) in SpecialtyList"
      :key="key">
      <div class="specialty-info">
        <div class="specialty-name">
          {{ item.specialty_name }} <span class="btn color-1 border-2 "
            v-if="SearchList.indexOf(item.specialty_name) > -1">
            已加入
          </span>
          <span class="btn color-1" v-else>
            +对比
          </span>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: '',
  data() {
    return {
      SpecialtyList: [],
      specialty_name: null,
      page: {
        pageNum: 1,
        pageSize: 33,
        total: 0
      },
      SearchList: []
    };
  },
  computed: {
    ...mapState(["userInfo"]),
    testtt() {
      if (this.userInfo.like_sp == null || this.userInfo.like_sp == '') return null
      return this.userInfo.like_sp.split('、')
    }
  },
  created() {
    this.getSpecialty()
  },
  methods: {
    searchName() {
      this.pageNum = 1
      this.getSpecialty()
    },
    getSpecialty() {
      let data = {}
      data.name = this.specialty_name
      data.pageNum = this.page.pageNum
      data.pageSize = this.page.pageSize
      data.score = this.userInfo.score
      this.$fecth.post('chats/get_specialty_list', data).then((res) => {
        this.loading = false
        this.SpecialtyList = res.lists
      })
    },
    addSpecialty(e) {
      let key = this.SearchList.indexOf(e)
      if (key > -1) {
        this.SearchList.splice(key, 1);
      } else {
        let splen = this.SearchList.length;
        if (splen == 3) {
          this.$alert("最多对比3个专业", "提示", {
            confirmButtonText: "确定",
          });
          return false;
        } else {
          this.SearchList.push(e)
        }
      }
    },

    getRefulsh() {
      this.page.pageNum++
      if (this.page.pageNum > 7) this.page.pageNum = 1
      this.getSpecialty()
    },

    onSearch() {
      let splen = this.SearchList.length;
      if (splen < 2) {
        this.$alert("请最少选择2个专业", "提示", {
          confirmButtonText: "确定",
        });
        return false;
      } else {
        let data = {
          title: this.SearchList.join('/') + '请结合我的信息综合分析一下这几个专业的填报策略',
          specialtyList: this.SearchList,
          type: 5
        }
        this.$emit('getChat', data)
      }
    }
  },
};
</script>

<style scoped lang='less'>
.refulsh {
  color: #008BFF;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;

  .huanyipi {
    display: flex;
    align-items: center;
    cursor: pointer;
  }
}


.search {
  margin-bottom: 20px
}

.specialty-item-like {
  padding: 15px 15px;
  border-radius: 8px;
  cursor: pointer;
  margin-bottom: 10px;
  display: inline-block;
  margin-right: 20px;
}

.specialty-item {
  padding: 15px 15px;
  border-radius: 8px;
  cursor: pointer;
  margin-bottom: 10px;
  display: inline-block;
  margin-right: 20px;
}

.specialty-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
}

.search-list {
  display: flex;
  padding-bottom: 30px;
  justify-content: space-between;

  .search-list-content {
    display: flex;

    .search-list-item {
      padding: 4px 10px;
      margin-right: 20px;
      position: relative;
      border-radius: 3px;
    }

    .search-title {
      margin-right: 0;
    }
  }
}
</style>
